var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagComoros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9994 15.9536H14.6551C11.2115 19.3972 9.12913 22.0558 7.00288 24.1821L16.0464 24.9971L30.0798 23.6057C31.3044 21.3436 32 18.753 32 15.9999C32 15.9844 31.9994 15.9691 31.9994 15.9536Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00265 8.3015H30.0284C27.3073 3.3535 22.0454 0 15.9997 0C11.5931 0 7.6034 1.78194 4.70996 4.664L7.00265 8.3015Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.699 23.6057C6.26063 25.0441 5.70475 26.2492 4.66406 27.2898C7.56125 30.199 11.5703 31.9999 16.0004 31.9999C22.0839 31.9999 27.3742 28.6046 30.0802 23.6057H7.699Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.63989C-1.56212 10.8883 -1.56212 21.019 4.68625 27.2674C7.26831 24.6853 9.75163 22.202 16 15.9536L4.68625 4.63989Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22079 15.9538C4.22079 13.6227 5.8591 11.6752 8.04685 11.1975C7.7106 11.124 7.36173 11.0842 7.00335 11.0842C4.31391 11.0842 2.13379 13.2644 2.13379 15.9538C2.13379 18.6432 4.31391 20.8234 7.00335 20.8234C7.36166 20.8234 7.71054 20.7835 8.04685 20.7101C5.8591 20.2323 4.22079 18.2849 4.22079 15.9538Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9927 11.7798L8.25176 12.5769H9.08988L8.41176 13.0696L8.67082 13.8667L7.9927 13.3741L7.31457 13.8667L7.57363 13.0696L6.89551 12.5769H7.73363L7.9927 11.7798Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9927 13.8667L8.25176 14.6639H9.08988L8.41176 15.1565L8.67082 15.9537L7.9927 15.461L7.31457 15.9537L7.57363 15.1565L6.89551 14.6639H7.73363L7.9927 13.8667Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9927 15.9539L8.25176 16.751H9.08988L8.41176 17.2437L8.67082 18.0408L7.9927 17.5481L7.31457 18.0408L7.57363 17.2437L6.89551 16.751H7.73363L7.9927 15.9539Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9927 18.0408L8.25176 18.8379H9.08988L8.41176 19.3306L8.67082 20.1277L7.9927 19.6351L7.31457 20.1277L7.57363 19.3306L6.89551 18.8379H7.73363L7.9927 18.0408Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagComoros);
export default __webpack_public_path__ + "static/media/flag_comoros.9e889bc4d7471455c2fafd62ba54dfde.svg";
export { ForwardRef as ReactComponent };